export default {"src":"/_next/static/media/chevron-down.49e1172c.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};